import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import AffiliateBanner from "./AffiliateBanner";
import PhoneRequiredGate from "./PhoneRequiredGate";

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col bg-white text-neutral-900 overflow-x-hidden">
      <AffiliateBanner />
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <PhoneRequiredGate />
    </div>
  );
}
